import React, { useMemo } from 'react';
import ChannelContext from './ChannelContext';
const ChannelProvider = ({ channelHandler, children, config }) => {
    const { channels, selectedChannel, recommendedChannel } = channelHandler;
    const value = useMemo(() => {
        const updateChannelSingleDomain = (newChannel) => {
            channelHandler.updateChannel({ config, newChannel });
        };
        const channelsById = {};
        channels &&
            channels.forEach((channel) => {
                channelsById[channel.id] = channel;
            });
        return {
            recommendedChannel,
            updateChannel: updateChannelSingleDomain,
            channels,
            selectedChannel,
            channelsById,
            basename: channelHandler.getChannelBasename() // TODO This isn't used anywhere?
        };
    }, [channelHandler, channels, config, recommendedChannel, selectedChannel]);
    return (React.createElement(ChannelContext.Provider, { value: value }, children));
};
export default ChannelProvider;
//# sourceMappingURL=ChannelProvider.js.map